import React from "react";

const ContactPage = () => {
  return <div>This is ContactPage</div>;
};

export default ContactPage;
